import styled from 'styled-components'

interface IndentProps {
	top: number
	right: number
	bottom: number
	left: number
}

export const Indent = styled.div<Partial<IndentProps>>`
	margin: ${({ top, right, bottom, left }) =>
		`${top ? `${top}px` : 0} ${right ? `${right}px` : 0} ${bottom ? `${bottom}px` : 0} ${
			left ? `${left}px` : 0
		}`};
`
